var map = {
	"./Setup/Edition.png": "YVi5",
	"./Setup/Journal.png": "Opgi",
	"./Setup/Stock.png": "+maw",
	"./Setup/accounts.png": "rKMj",
	"./Setup/cash.png": "U+on",
	"./Setup/copewith.png": "cYgT",
	"./Setup/enterprise.png": "PmBY",
	"./Setup/parameter.png": "kMQl",
	"./Setup/receivable.png": "xK0X",
	"./Setup/reconstruction.png": "0vg1",
	"./Setup/审核设置.png": "Jo+q",
	"./Setup/操作日志.png": "k29I",
	"./Setup/支付配置.png": "U9yM",
	"./Setup/系统任务.png": "TCDR",
	"./Setup/菜单配置.png": "dCw9",
	"./data/all_operation.png": "F7Zl",
	"./data/bank_account.png": "AMUm",
	"./data/commodity_codes.png": "Marp",
	"./data/cost_type.png": "ZySg",
	"./data/customer.png": "53PO",
	"./data/department_staff.png": "NpWf",
	"./data/goods.png": "mxDP",
	"./data/image_management.png": "ojnL",
	"./data/logistics_company.png": "8GtH",
	"./data/other_income.png": "2GSe",
	"./data/permissions.png": "nL4W",
	"./data/price_management.png": "MFsK",
	"./data/regional_information.png": "ko8a",
	"./data/secondary_data.png": "+0gV",
	"./data/supplier.png": "3NnU",
	"./data/warehouse_information.png": "WMc5",
	"./money/caiwu1.png": "ocoZ",
	"./money/caiwu2.png": "6CKY",
	"./money/caiwu3.png": "YVHr",
	"./money/caiwu4.png": "B3cW",
	"./money/shoufu1.png": "/LA+",
	"./money/shoufu2.png": "UuD8",
	"./money/tiaozheng1.png": "xzmV",
	"./money/wanglai1.png": "jD2d",
	"./money/wanglai2.png": "SLb7",
	"./money/wanglai3.png": "7dME",
	"./money/wanglai4.png": "eY8w",
	"./money/其他收入.png": "tmL5",
	"./money/往来清账.png": "PYLJ",
	"./money/待确认款项.png": "2P1B",
	"./money/按单收款.png": "4ep0",
	"./money/收款统计.png": "DDWW",
	"./money/查应付.png": "2cGF",
	"./money/查应收.png": "vrhf",
	"./money/职员部门应收款.png": "Durd",
	"./money/账龄分析.png": "UvO0",
	"./money/费用单.png": "tNYq",
	"./money/超期应收查询.png": "Fd+W",
	"./money/预收款单.png": "QSv5",
	"./nav/accounting.png": "IUgm",
	"./nav/data.png": "icGC",
	"./nav/financial.png": "n/6J",
	"./nav/money.png": "3gUQ",
	"./nav/purchase.png": "Lwji",
	"./nav/report1.png": "QGM5",
	"./nav/report2.png": "VAi1",
	"./nav/sale.png": "Ooro",
	"./nav/set.png": "lnKz",
	"./nav/warehouse.png": "4RtU",
	"./procurement/checkinventory.png": "w18g",
	"./procurement/orderpin.png": "xMns",
	"./procurement/procurementorder.png": "U6Bz",
	"./procurement/purchasecostsharing.png": "XeFc",
	"./procurement/purchasehistory.png": "Eo5a",
	"./procurement/purchasereceipt.png": "U/PB",
	"./procurement/purchasereexchange.png": "XoM8",
	"./procurement/purchasereturn.png": "xdz0",
	"./procurement/replenishment.png": "jnYp",
	"./procurement/smartreplenishment.png": "oTbf",
	"./procurement/warningready.png": "eO1u",
	"./report/business_center1.png": "dUtg",
	"./report/business_center2.png": "jwNI",
	"./report/business_center3.png": "rOgK",
	"./report/business_center4.png": "0IqI",
	"./report/business_center5.png": "+fjd",
	"./report/business_center6.png": "2pJG",
	"./report/business_process.png": "waIk",
	"./report/capital_report1.png": "dRNo",
	"./report/capital_report2.png": "rzE2",
	"./report/capital_report3.png": "vkic",
	"./report/capital_report4.png": "Wr7G",
	"./report/capital_report5.png": "IWM2",
	"./report/check_inventory1.png": "F6Z9",
	"./report/check_inventory2.png": "m/aA",
	"./report/check_inventory3.png": "7aK1",
	"./report/check_inventory4.png": "g1Z3",
	"./report/check_inventory5.png": "yNeS",
	"./report/documents_charged.png": "k4LG",
	"./report/draft_business.png": "J1G3",
	"./report/order_statistics1.png": "tTad",
	"./report/order_statistics2.png": "eaGx",
	"./report/order_statistics3.png": "WHhE",
	"./report/pending_documents.png": "iTxi",
	"./report/purchasing_report1.png": "tGwq",
	"./report/purchasing_report2.png": "SSmF",
	"./report/purchasing_report3.png": "HwNQ",
	"./report/sales_reports1.png": "i/jD",
	"./report/sales_reports2.png": "ONDa",
	"./report/sales_reports3.png": "NIjO",
	"./report/sales_reports4.png": "I4DL",
	"./report/sales_reports5.png": "6Lg3",
	"./report/sales_reports6.png": "e7Tg",
	"./report/sales_reports7.png": "00f3",
	"./sale/exchangeorder.png": "x0cw",
	"./sale/historyorder.png": "QWhP",
	"./sale/order.png": "sQc/",
	"./sale/outorder.png": "4XYv",
	"./sale/pricetracking.png": "PzNp",
	"./sale/retailorder.png": "Rl9A",
	"./sale/returnorder.png": "SkUl",
	"./sale/salehistory.png": "ttJF",
	"./warehouse/danju_1.png": "NujT",
	"./warehouse/danju_2.png": "UX4v",
	"./warehouse/danju_3.png": "Q22F",
	"./warehouse/danju_4.png": "xh6G",
	"./warehouse/diaobo_1.png": "/eO0",
	"./warehouse/diaobo_2.png": "qG2O",
	"./warehouse/qitadanju_1.png": "Urg4",
	"./warehouse/qitadanju_2.png": "tEMd",
	"./warehouse/借进借出历史.png": "pRTa",
	"./warehouse/其他出入库历史.png": "1Ey+",
	"./warehouse/分量盘点.png": "/NQD",
	"./warehouse/发货.png": "zaMf",
	"./warehouse/库存预警查询.png": "4HeO",
	"./warehouse/库存预警设置.png": "xtC1",
	"./warehouse/报损报溢历史.png": "SeKq",
	"./warehouse/收货.png": "xtav",
	"./warehouse/生产模板.png": "omo3",
	"./warehouse/生产计划.png": "yWWz",
	"./设置/企业信息.png": "4OJe",
	"./设置/审核设置.png": "zlZL",
	"./设置/库存期初.png": "Guz1",
	"./设置/应付期初.png": "E3i3",
	"./设置/应收期初.png": "TZtV",
	"./设置/操作日志.png": "M7ZZ",
	"./设置/支付配置.png": "mV4F",
	"./设置/现金银行期初.png": "uLXU",
	"./设置/系统任务.png": "ZPim",
	"./设置/系统参数.png": "7U4p",
	"./设置/系统开账.png": "ElEy",
	"./设置/系统重建.png": "InBK",
	"./设置/菜单配置.png": "jRXk",
	"./资金/付款单.png": "yv9v",
	"./资金/付款统计.png": "J9ul",
	"./资金/其他收入.png": "vJFK",
	"./资金/应收应付调整.png": "ldl/",
	"./资金/往来清账.png": "Vq4C",
	"./资金/待确认款项.png": "wKIr",
	"./资金/按单付款.png": "XASL",
	"./资金/按单收款.png": "IeN3",
	"./资金/提现存现转款.png": "s1ip",
	"./资金/收款单.png": "tHgy",
	"./资金/收款统计.png": "0Vqa",
	"./资金/查应付.png": "t4G6",
	"./资金/查应收.png": "oMvz",
	"./资金/职员部门应收款.png": "oVXQ",
	"./资金/账龄分析.png": "o21m",
	"./资金/费用单.png": "Wz4/",
	"./资金/超期应收查询.png": "08BN",
	"./资金/预付款单.png": "BmQH",
	"./资金/预收款单.png": "vCDT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "soe4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/.*$
// module id = soe4
// module chunks = 95